
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-fill-url-text-v1',
    templateUrl: './fill-url-text-v1.component.html'
})
export class FillUrlTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Type the link here";
    public value: string = "";
    public valid: boolean = false;


    ngOnInit(): void {// Set the value only if the provided field value is not an empty string
        if (this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.trim() !== '') {
            this.value = this.fieldSubmission.serialized_value;  // Set the value without triggering the input event
            this.valid = this.value.trim() !== ''; // Update validity
        } else {
            this.valid = !this.fieldSubmission.field.mandatory;
        }
        this.emitValidity();
    }

    onValueChange(value: string ) {
        this.value = value;
         // URL validation regex tested with google search in https://regex101.com/
        // const urlRegex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})(\/[\w.-]*)*(\?[=&#%+\w.-]*)?\/?$/; // in case we permit specific chars in query: =&#%+
        const urlRegex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})(\/[\w.-]*)*(\?.*)?\/?$/;
        // Check validity: No leading/trailing spaces and valid URL format
        this.valid = value === value.trim() && urlRegex.test(value.toLowerCase()) || (!this.fieldSubmission.field.mandatory && this.value === ''); 
        // console.log(" TExt urllll value----> ", value);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: value});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.valid });
    }

}
